import baseDataProvider from 'data-provider/rest-client';

export function userUpdateHandler(resource, params) {
  // if (!params.data) {
  return baseDataProvider.update(resource, params);
  // }
}
